import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Camera, Sparkles } from "lucide-react";
import { SnapToPriceModal } from "./SnapToPriceModal";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface SnapToPriceButtonProps {
  variant?: "default" | "outline" | "ghost" | "fab";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
  showLabel?: boolean;
}

export function SnapToPriceButton({ 
  variant = "default", 
  size = "default",
  className,
  showLabel = true 
}: SnapToPriceButtonProps) {
  const [open, setOpen] = useState(false);

  if (variant === "fab") {
    return (
      <>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={() => setOpen(true)}
              className={cn(
                "fixed bottom-6 left-6 z-50 flex items-center justify-center",
                "h-14 w-14 rounded-full shadow-2xl",
                "bg-white text-violet-600",
                "ring-2 ring-violet-200",
                "hover:shadow-xl hover:scale-105 active:scale-95",
                "transition-all duration-200",
                className
              )}
              aria-label="Snap to Price - Get instant AI valuation"
            >
              <Camera className="h-6 w-6" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="right" className="bg-violet-600 text-white border-violet-500">
            <p className="font-medium">Snap to Price</p>
            <p className="text-xs text-violet-200">Get instant AI valuation</p>
          </TooltipContent>
        </Tooltip>
        <SnapToPriceModal open={open} onOpenChange={setOpen} />
      </>
    );
  }

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={() => setOpen(true)}
        className={cn("gap-2", className)}
      >
        <Sparkles className="h-4 w-4" />
        {showLabel && "Snap to Price"}
      </Button>
      <SnapToPriceModal open={open} onOpenChange={setOpen} />
    </>
  );
}
